"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/*
// Add your app's dependencies below
// EXclude your `peerDependencies` as these are provided automatically via webpack
// Use `import * as varName` for libraries where you import properties other than `default`
import gasketFetch from '@gasket/fetch';
import * as reactRedux from 'react-redux';
import * as reduxSaga from 'redux-saga';
import * as reduxStarterKit from 'redux-starter-kit';
import socialSdkCore from '@social-sdk/core';
const deps = {
  gasketFetch,
  reactRedux,
  reduxSaga,
  reduxStarterKit,
  socialSdkCore
};
export default deps;
*/
var deps = {};
var _default = exports.default = deps;